export default __webpack_public_path__ + "static/media/googleicon.df15d8e5.svg";